import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlightsMobileScreen from './mobile/FlightsMobileScreen';
import FlightsDesktopScreen from './desktop/FlightsDesktopScreen';
import FlightsScreenController from './FlightsScreenController';
import RoutesSwitchController from '../../components/flights/routesSwitch/RoutesSwitchController';
import TripsSwitchController from '../../components/flights/tripsSwitch/TripsSwitchController';
import ScreenDetection from '../../components/ScreenDetection';
import ProgressBarCenter from '../../components/ProgressBarCenter';
import Navigation from '../../components/navigation/Navigation';
import Constants from '../../model/AppConfiguration';

/**
 * ## Redux imports
 */
import * as routesActions from '../../redux/actions/RoutesActions';
import * as flightsActions from '../../redux/actions/FlightsActions';
import * as allFlightsActions from '../../redux/actions/AllFlightsActions';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import selectors from '../../redux/selectors/Index';

/**
 * ## Redux boilerplate
 */
const actions = [ routesActions, flightsActions, allFlightsActions ];

function mapStateToProps (state) {
  return {
    isFetching: selectors.global.isFetching(state.global),
    general: selectors.general.getAll(state.general),
    navigation: selectors.navigation.getNavigation(state.navigation),
    routes: selectors.routes.getRoutes(state.routes),
    flights: selectors.flights.getFlights(state.flights),
    allFlights: selectors.allFlights.getAllFlights(state.allFlights),
  };
}

function mapDispatchToProps (dispatch) {
  const creators = Map()
    .merge(...actions)
    .filter(value => typeof value === 'function')
    .toObject();

  return {
    actions: bindActionCreators(creators, dispatch),
    dispatch,
  };
}

class FlightsScreen extends Component {
  static propTypes = {
    actions: PropTypes.object,
    isFetching: PropTypes.bool,
    allFlights: PropTypes.arrayOf(PropTypes.object),
    flights: PropTypes.arrayOf(PropTypes.object),
    routes: PropTypes.arrayOf(PropTypes.object),
    general: PropTypes.object,
  };

  constructor (props) {
    super(props);

    this.findRouteById = FlightsScreenController.findRouteById.bind(this);
    this.findTripByRoute = FlightsScreenController.findTripByRoute.bind(this);
    this.setUpReturnFlight = FlightsScreenController.setUpReturnFlight.bind(this);
    let trips = [ { id: '1', label: 'One Way' }, { id: '2', label: 'Round Trip' } ];
    this.state = {
      selectedRoute: null,
      selectedTrip: trips[ 0 ],
      trips: trips,
      submitData: null,
    };
    this.toggleRoutes = RoutesSwitchController.toggleRoutes.bind(this);
    this.toggleTrips = TripsSwitchController.toggleTrips.bind(this);

    props.actions.getFlights(Constants.REQUEST.FLIGHTS);
  }

  componentWillReceiveProps (props) {
    const { flights, routes, allFlights, isFetching, general } = props;
    let selectedTrip = this.state.selectedTrip;

    let firstFlight = selectors.flights.getFlight(flights, 1);
    let routeId = firstFlight ? firstFlight.routeId : null;
    let reservationId = 0;

    if (!isFetching && !this.state.selectedRoute && routes && routes.length) {
      this.setState({
        selectedRoute: this.findRouteById(routeId, routes),
        selectedTrip: this.findTripByRoute(flights),
      });
    }
    if (!isFetching && !routes) {
      this.props.actions.getRoutes();
    }
    if (
      !isFetching &&
      routes &&
      routeId &&
      (!allFlights || (this.state.selectedRoute && routeId !== this.state.selectedRoute.id))
    ) {
      this.props.actions.getAllFlights(reservationId, routeId);
    }

    if (general && general.trip) {
      let trips = this.state.trips;
      if (trips) {
        let trip = trips.find(localTrip => localTrip.id == general.trip.segments);
        if (trip) {
          this.setState({ selectedTrip: trip });
        }
      }
    }

    if (
      allFlights &&
      allFlights.length &&
      selectedTrip &&
      selectedTrip.id === Constants.flights.oneWay &&
      flights.length === 1
    ) {
      this.setUpReturnFlight(allFlights);
    }
  }

  setSubmitData = child => {
    if (this && child) {
      if (!this.state.submitData) this.setState({ submitData: child.submitData });
    }
  };

  render () {
    const { selectedRoute, selectedTrip, trips } = this.state;
    const { routes, flights, general } = this.props;
    if (!selectedRoute || !routes) {
      return <ProgressBarCenter />;
    }

    return (
      <Navigation
        submitData={this.state.submitData}
        screen={
          <ScreenDetection
            mobileScreen={
              <FlightsMobileScreen
                flights={flights}
                general={general}
                selectedRoute={selectedRoute}
                routes={routes}
                toggleRoutes={this.toggleRoutes}
                selectedTrip={selectedTrip}
                trips={trips}
                toggleTrips={this.toggleTrips}
                ref={this.setSubmitData}
                submitFlights={this.props.actions.submitFlights}
              />
            }
            desktopScreen={
              <FlightsDesktopScreen
                routes={routes}
                general={general}
                flights={flights}
                selectedRoute={selectedRoute}
                toggleRoutes={this.toggleRoutes}
                selectedTrip={selectedTrip}
                toggleTrips={this.toggleTrips}
                ref={this.setSubmitData}
                submitFlights={this.props.actions.submitFlights}
              />
            }
          />
        }
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FlightsScreen);



// WEBPACK FOOTER //
// ./src/containers/flights/FlightsScreen.js